import React, { useState, useEffect } from "react";
import Form from "react-bootstrap/Form";
import Row from "react-bootstrap/Row";
import { useDispatch, useSelector } from "react-redux";
import { addLead, resetLead } from "../../redux/actions-exporter";
import Button from "react-bootstrap/Button";

import MainBtn from "../repeats/mainBtn/MainBtn";
import Pros from "../pros/Pros";
import Reviews from "../reviews/Reviews";
import Footer from "../footer/Footer";
import SideGallery from "../repeats/sideGallery/SideGallery";
import WhereAndWhen from "../repeats/whereAndWhen/WhereAndWhen";
import PersonalDetails from "../repeats/personalDetails/PersonalDetails";
import PaymentSuccess from "../repeats/paymentSuccess/PaymentSuccess";
import Post from "../blog/Post";

import office from "../../assets/images/MOF/half.jpg";
import office1 from "../../assets/images/MOF/boxes-in-a-new-building-with-a-laptop-and-paperwork-edit-845x684.jpg";
import office2 from "../../assets/images/MOF/office-relcoation-india.jpg";
import office3 from "../../assets/images/MOF/Fireman_movers-e1504247450706.jpg";
import office4 from "../../assets/images/MOF/The-Benefits-Of-Using-A-Moving-Company-When-Relocating-Your-Business-1280x720.jpeg";
import office5 from "../../assets/images/MOF/office.jpg";
import office6 from "../../assets/images/MOF/What-mistakes-should-I-avoid-when-moving-my-office.jpg";

import img1 from "../../assets/images/Blog/1.jpg";

const LEAD_SOURCE = "הובלת משרדים/מפעלים";

const TransportOffice = ({ mainLogo }) => {
  const dispatch = useDispatch();
  const [start, setStart] = useState(true);
  const [validated, setValidated] = useState(false);
  const [send, setSend] = useState(false);
  const [fromaddress, setFromaddress] = useState("");
  const [toaddress, setToaddress] = useState("");
  useEffect(() => {
    if (start || send) document.querySelector(".homeTitle").scrollIntoView();
    setStart(false);
  }, [send]);

  const [form, setForm] = useState({
    source: LEAD_SOURCE,
    extraFields: { fromaddress: "", toaddress: "" },
  });
  const addedLead = useSelector((state) => state.lead.addedLead);

  useEffect(() => {
    if (addedLead) {
      setSend(true);
      setForm({ source: LEAD_SOURCE });
      dispatch(resetLead());
    }
  }, [addedLead]); // eslint-disable-line

  const handleSend = (e) => {
    e.preventDefault();
    if (e.currentTarget.checkValidity() === false) {
      e.stopPropagation();
    } else {
      dispatch(addLead(form, "only_delivery"));
    }
    setValidated(true);
  };

  const handleOnPlaceSelected = (place, inputRefTo) => {
    if (inputRefTo.name === "fromaddress") {
      setFromaddress(place.formatted_address);
    } else if (inputRefTo.name === "toaddress") {
      setToaddress(place.formatted_address);
    }
  };
  const [moveDate, setMoveDate] = useState("");

  const onDateChange = (date, field) => {
    setForm({
      ...form,
      extraFields: {
        ...form.extraFields,
        [field]: date,
      },
    });
    setMoveDate(date);
  };

  useEffect(() => {
    setForm({ ...form, extraFields: { fromaddress, toaddress } });
  }, [fromaddress, toaddress]);
  const galleryArr = [
    {
      img: office1,
    },
    {
      img: office2,
    },
    {
      img: office3,
    },
    {
      img: office4,
    },
    {
      img: office5,
    },
    {
      img: office6,
    },
  ];

  return (
    <div className="transportFewItems">
      {console.log(form)}
      <div className="page_banner">
        <img src={office} alt="" />
        <div className="banner_content">
          <div className="banner_title">
            <h1>הובלת משרדים/מפעלים</h1>
            <p>שירות בכל רחבי הארץ באמינות ודיוק ללא פשרות</p>
          </div>
          <div className="btnDiv">
            <MainBtn text="חזרה" link="/transport" />
            {/* <MainBtn text='דירות ובתים' link='#' isLight={true} /> */}
          </div>
        </div>
      </div>

      <Pros />

      <div className="servicesDiv">
        <h1 className="homeTitle">הובלת משרדים/מפעלים</h1>
        <div className="splitDiv">
          <div className="imagesSide">
            <SideGallery
              mainImg={mainLogo}
              header="שירותי הובלות"
              galleryArr={galleryArr}
            />
          </div>

          <div className="formSide">
            {send ? (
              <PaymentSuccess
                text1="תודה שבחרת בנו!"
                text2="נציג יחזור אליך בהקדם"
              />
            ) : (
              <>
                <Form
                  className="formBox"
                  noValidate
                  validated={validated}
                  onSubmit={handleSend}
                >
                  <WhereAndWhen
                    handleOnPlaceSelected={handleOnPlaceSelected}
                    onChange={(e) =>
                      setForm({
                        ...form,
                        extraFields: {
                          ...form.extraFields,
                          [e.target.name]: e.target.value,
                        },
                      })
                    }
                    onDateChange={onDateChange}
                    moveDate={moveDate}
                  />

                  <Row className="mb-3 row">
                    <Form.Group className="mb-3" controlId="formBasicName">
                      <Form.Label className="fw-semibold mb-2">
                        סוג הובלה
                      </Form.Label>
                      <Form.Select
                        required
                        name="transporttype"
                        onChange={(e) =>
                          setForm({
                            ...form,
                            extraFields: {
                              ...form.extraFields,
                              [e.target.name]: e.target.value,
                            },
                          })
                        }
                      >
                        <option value="">משרד/מפעל</option>
                        <option value="office">משרד</option>
                        <option value="factory">מפעל</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        נא לבחור סוג הובלה
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Row>

                  <PersonalDetails
                    onChange={(field) => setForm({ ...form, ...field })}
                  />
                  <Button
                    style={{
                      background: "var(--primary)",
                      border: "none",
                      width: "100%",
                    }}
                    text="לקבלת הצעת מחיר"
                    type="submit"
                    className="filter-btn"
                  >
                    לקבלת הצעת מחיר
                  </Button>
                </Form>
              </>
            )}
          </div>
        </div>
      </div>

      <Reviews />
      <div className="articlesDiv">
        <Post
          title="טיפים לאריזה"
          img={img1}
          text="  לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית קולהע צופעט למרקוח איבן איף, ברומץ כלרשט מיחוצים. קלאצי קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח. עמחליף נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן צש בליא, מנסוטו צמלח לביקו ננבי, צמוקו בלוקריה שיצמה ברורק. קולהע צופעט למרקוח איבן איף, ברומץ כלרשט מיחוצים. קלאצי לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית. סת אלמנקום ניסי נון ניבאה. דס איאקוליס וולופטה דיאם. וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק. קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.        נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן קוואזי במר מודוף.אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף לפרומי בלוף קינץ תתיח לרעח.לת צשחמי מוסן מנת.להאמית קרהשק סכעיט דז מא, מנכם למטכין נשואי מנורך.קונסקטורר אדיפיסינג אלית.סת אלמנקום ניסי נון ניבאה.דס איאקוליס וולופטה דיאם.וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק.קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.         קולורס מונפרד אדנדום סילקוף, מרגשי ומרגשח.עמחליף נולום ארווס סאפיאן - פוסיליס קוויס, אקווזמן קוואזי במר מודוף.אודיפו בלאסטיק מונופץ קליר, בנפת נפקט למסון בלרק - וענוף ליבם סולגק.בראיט ולחת צורק מונחף, בגורמי מגמש.תרבנך וסתעד לכנו סתשם השמה - לתכי מורגם בורק ? לתיג ישבעס.        קונדימנטום קורוס בליקרה, נונסטי קלובר בריקנה סטום, לפריקך תצטריק לרטי.        לורם איפסום דולור סיט אמט, קונסקטורר אדיפיסינג אלית.סת אלמנקום ניסי נון ניבאה.דס איאקוליס וולופטה דיאם.וסטיבולום אט דולור, קראס אגת לקטוס וואל אאוגו וסטיבולום סוליסי טידום בעליק.הועניב היושבב שערש שמחויט - שלושע ותלברו חשלו שעותלשך וחאית נובש ערששף.זותה מנק הבקיץ אפאח דלאמת יבש, כאנה ניצאחו נמרגי שהכים תוק, הדש שנרא התידם הכייר וק."
        />
      </div>

      <Footer />
    </div>
  );
};

export default TransportOffice;
